import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = [
    "container",
    "template",
    "row",
    "rowNumber",
    "ownerInput",
    "removeButton",
    "removeLabel",
    "removeIcon",
    "dragHandle",
    "selectRoot",
    "selectTrigger",
    "selectLabel",
    "selectClear",
    "selectDropdown",
    "selectSearchWrap",
    "selectSearch",
    "selectLoading",
    "selectOptions",
    "selectLoadingMore"
  ]

  connect() {
    this.idSequence = 0
    if (this.rowTargets.length === 0) this.addRowFromTemplate()
    this.assignRowElementIds()
    this.sortable = Sortable.create(this.containerTarget, {
      handle: ".sortable-handle",
      animation: 150,
      ghostClass: "opacity-50",
      onEnd: () => this.assignRowElementIds(),
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  add(event) {
    event.preventDefault()
    this.addRowFromTemplate()
    this.assignRowElementIds()
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-owners-form-target='row']")
    if (!row) return

    row.remove()
    if (this.rowTargets.length === 0) this.addRowFromTemplate()
    this.assignRowElementIds()
  }

  addRowFromTemplate() {
    const fragment = this.templateTarget.content.cloneNode(true)
    this.containerTarget.appendChild(fragment)
  }

  assignRowElementIds() {
    this.rowTargets.forEach((row, index) => {
      if (!row.dataset.rowToken) {
        row.dataset.rowToken = this.generateRowToken()
      }

      const token = row.dataset.rowToken
      const prefix = `thing-owner-select-${token}`
      row.id = `thing-owner-row-${token}`

      if (this.rowNumberTargets[index]) {
        this.rowNumberTargets[index].id = `thing-owner-row-number-${token}`
        this.rowNumberTargets[index].textContent = String(index + 1)
      }

      if (this.removeButtonTargets[index]) this.removeButtonTargets[index].id = `thing-owner-remove-button-${token}`
      if (this.removeLabelTargets[index]) this.removeLabelTargets[index].id = `thing-owner-remove-button-label-${token}`
      if (this.removeIconTargets[index]) this.removeIconTargets[index].id = `thing-owner-remove-button-icon-${token}`
      if (this.dragHandleTargets[index]) this.dragHandleTargets[index].id = `thing-owner-drag-handle-${token}`

      if (this.selectRootTargets[index]) this.selectRootTargets[index].id = prefix
      if (this.ownerInputTargets[index]) this.ownerInputTargets[index].id = `${prefix}-value`
      if (this.selectTriggerTargets[index]) {
        this.selectTriggerTargets[index].id = `${prefix}-trigger`
        this.selectTriggerTargets[index].setAttribute("aria-controls", `${prefix}-dropdown`)
      }
      if (this.selectLabelTargets[index]) this.selectLabelTargets[index].id = `${prefix}-label`
      if (this.selectClearTargets[index]) this.selectClearTargets[index].id = `${prefix}-clear`
      if (this.selectDropdownTargets[index]) this.selectDropdownTargets[index].id = `${prefix}-dropdown`
      if (this.selectSearchWrapTargets[index]) this.selectSearchWrapTargets[index].id = `${prefix}-search-wrap`
      if (this.selectSearchTargets[index]) this.selectSearchTargets[index].id = `${prefix}-search`
      if (this.selectLoadingTargets[index]) this.selectLoadingTargets[index].id = `${prefix}-loading`
      if (this.selectOptionsTargets[index]) this.selectOptionsTargets[index].id = `${prefix}-options`
      if (this.selectLoadingMoreTargets[index]) this.selectLoadingMoreTargets[index].id = `${prefix}-loading-more`
    })
  }

  generateRowToken() {
    this.idSequence += 1
    const randomFiveDigits = Math.floor(Math.random() * 90000) + 10000
    const sequenceThreeDigits = String(this.idSequence % 1000).padStart(3, "0")
    return `${Date.now()}${randomFiveDigits}${sequenceThreeDigits}`
  }
}
